import { IonContent, IonHeader, IonPage, IonToolbar } from "@ionic/react";
import React, { useEffect, useState } from "react";
import Header from "../components/layout/Header";
import { Helmet } from "react-helmet-async";

const LocalhostIframe = () => {
  const [aiResponse, setAiResponse] = useState(null);

  useEffect(() => {
    const handleMessage = (event) => {
      // Security check - verify origin
      if (event.origin !== "http://localhost:8501") return;

      // if (event.data.type === "aiResponse") {
      //     setAiResponse(event.data.data);
      //     console.log("Received aiResponse:", event.data.data);
      // }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <IonPage>
        <IonHeader mode="ios">
          <Header />
        </IonHeader>
        <IonContent>
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ flex: 1, minHeight: 300, position: "relative" }}>
              <iframe
                src="https://travel.loonlog.ca" // Usually http for localhost
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  display: "block",
                }}
                frameBorder="0"
                title="Localhost AI"
                allowFullScreen
              />
            </div>
            <div
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                padding: "10px",
                borderRadius: "5px",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                zIndex: 1000,
                maxWidth: "300px",
                wordWrap: "break-word",
                margin: "10px",
                alignSelf: "flex-start",
              }}
            >
              {/* <strong>AI Response:</strong> {aiResponse || "Waiting..."} */}
            </div>
          </div>
        </IonContent>
      </IonPage>
    </>
  );
};

export default LocalhostIframe;
